export const FETCH_DATASPACES = 'FETCH_DATASPACES';
export const FETCH_MY_DATASPACES = 'FETCH_MY_DATASPACES';
export const FETCH_DS_DETAILS = 'FETCH_DS_DETAILS';
export const CHECK_MY_DS_STATUS = 'CHECK_MY_DS_STATUS';
export const FETCH_MY_DS_DETAILS = 'FETCH_MY_DS_DETAILS';
export const CLEAR_MY_DS_STATUS = 'CLEAR_MY_DS_STATUS';
export const SEND_REQ_FOR_DS = 'SEND_REQ_FOR_DS';
